import { FC } from 'react';

interface ErrorIconProps {
	className?: string;
	width?: number;
	height?: number;
}

export const ErrorIcon: FC<ErrorIconProps> = ({ className = '', width = 24, height = 24 }) => (
	<svg className={className} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 32 32" fill="none">
		<mask id="mask0_31_826" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
			<path fillRule="evenodd" clipRule="evenodd" d="M16 32C7.17733 32 0 24.8227 0 16C0 7.17733 7.17733 0 16 0C24.8227 0 32 7.17733 32 16C32 24.8227 24.8227 32 16 32ZM16 2C8.28 2 2 8.28 2 16C2 23.72 8.28 30 16 30C23.72 30 30 23.72 30 16C30 8.28 23.72 2 16 2ZM16 19C15.448 19 15 18.552 15 18V7C15 6.448 15.448 6 16 6C16.552 6 17 6.448 17 7V18C17 18.552 16.552 19 16 19ZM17.5 22.5C17.5 23.3284 16.8284 24 16 24C15.1716 24 14.5 23.3284 14.5 22.5C14.5 21.6716 15.1716 21 16 21C16.8284 21 17.5 21.6716 17.5 22.5Z" fill="white" />
		</mask>
		<g mask="url(#mask0_31_826)">
			<rect width="32" height="32" fill="#D0021B" />
		</g>
	</svg>
);
